/**
 * Bridges Capacitor push registration to the backend.
 *
 * On native platforms this requests permission, obtains the FCM/APNs token,
 * and registers it with the backend so the user's devices can receive pushes.
 * On web it no-ops (the underlying Capacitor calls bail out off-device).
 */
import { notificationsAPI } from '../api/client';
import { isNativePlatform, platform, registerPushNotifications } from './index';

const PUSH_TOKEN_KEY = 'push_token';

export async function syncPushRegistration(): Promise<void> {
  if (!isNativePlatform) return;
  try {
    await registerPushNotifications(async (token) => {
      try {
        await notificationsAPI.registerDevice(token, platform);
        localStorage.setItem(PUSH_TOKEN_KEY, token);
      } catch {
        // Non-fatal: a failed registration shouldn't block using the app.
      }
    });
  } catch {
    // Permission denied or unavailable — ignore.
  }
}

export async function unregisterPush(): Promise<void> {
  const token = localStorage.getItem(PUSH_TOKEN_KEY);
  if (!token) return;
  try {
    await notificationsAPI.unregisterDevice(token);
  } catch {
    // ignore
  }
  localStorage.removeItem(PUSH_TOKEN_KEY);
}
